import { React, useState } from 'react'
import ResetPasswordStepOne from './ResetPasswordStepOne';
import ResetPasswordStepTwo from './ResetPasswordStepTwo';
import ResetPasswordStepThree from './ResetPasswordStepThree';

export default function ResetPasswordContent() {
    const [step, setStep] = useState(1);
    const [userEmail, setUserEmail] = useState('');

    const changeStep = (requestedEmail) => {
        setStep(step+1);
        setUserEmail(requestedEmail);
    }
    const steps = [
        <ResetPasswordStepOne changeStep={changeStep} />,
        <ResetPasswordStepTwo changeStep={changeStep} userEmail={userEmail} />,
        <ResetPasswordStepThree userEmail={userEmail} />
    ]
  return (
    <div className='row g-0 min-vh-100 align-items-center'>
        <div className='col-lg-3 col-md-2'></div>
        <div className='col-lg-6 col-md-8 px-md-0 px-4'>
            {steps[step-1]}
        </div>
        <div className='col-lg-3 col-md-2'></div>
    </div>
  )
}
